import React, { useEffect, useState } from 'react';
import Dialog from 'components/dialogs/Dialog';
import { IconButton, InputAdornment, styled, TextField, Tooltip, Typography } from '@mui/material';
import { moneyFormat } from 'helpers/moneyFormat';
import MoneyInput from 'components/masked-input/MoneyInput';
import { toast } from 'react-toastify';
import { useNewSurgerie } from '../hooks/useNewSurgerie';
import { Done } from '@mui/icons-material';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface EditAnesthetistValueDialogProps {
  onExited(): void;
}

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
  padding: 10,
}));

const Content = styled('div')({
  marginTop: 20,
});

const EditAnesthetistValueDialog: React.FC<EditAnesthetistValueDialogProps> = ({ onExited }) => {
  const [value, setValue] = useState(0);
  const { surgerie, handleChange } = useNewSurgerie();

  useEffect(() => {
    setValue(surgerie.value_anesthetist || 0);
  }, [surgerie.value_anesthetist]);

  function handleSubmit() {
    handleChange('value_anesthetist', value);
    onExited();
  }

  function handleValidation() {
    if (value < (surgerie.procedure?.anesthetist?.sale_price_min || 0)) {
      toast.error('O valor do anestesista é menor que o valor mínimo permitido.');
      return;
    }
    handleSubmit();
  }

  return (
    <Dialog
      onExited={onExited}
      title="Editar valor do anestesista"
      maxWidth="md"
      ComponentActions={
        <Tooltip title="Salvar">
          <IconButton size="small" color="inherit" onClick={handleValidation}>
            <Done />
          </IconButton>
        </Tooltip>
      }
    >
      <Container>
        <Typography variant="body2">
          Valor de venda mínimo: <b>{moneyFormat(surgerie.procedure?.anesthetist?.sale_price_min)}</b>
        </Typography>
        <Typography variant="body2">
          Valor de venda máximo: <b>{moneyFormat(surgerie.procedure?.anesthetist?.sale_price_max)}</b>
        </Typography>

        <Content>
          <TextField
            fullWidth
            label="Novo valor"
            variant="outlined"
            size="small"
            value={value}
            onChange={e => setValue(Number(e.target.value))}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                inputComponent: asInputComponent(MoneyInput),
              },
            }}
          />
        </Content>
      </Container>
    </Dialog>
  );
};

export default EditAnesthetistValueDialog;
